import { RiseLoader } from "react-spinners";

export default function Login() {

  return (

    <div className="page-loader">
      <div className="img-loader">
        <RiseLoader color={'#3f5bea'} />
      </div>
    </div>

  );
}
